import React from "react";
import { Helmet } from "react-helmet-async";
import $ from "jquery";

import logo1 from "../img/ethervueblack.png";
import logo2 from "../img/ethervuewhite.png";

class Navbar extends React.Component {
  constructor() {
    super();
    this.state = {
      logo: logo1
    };
  }

  componentDidMount() {
    const nav = $("nav");
    let navHeight = nav.outerHeight();

    $(".navbar-toggler").on("click", function() {
      if (!$("#mainNav").hasClass("navbar-reduce")) {
        $("#mainNav").addClass("navbar-reduce");
      }
    });

    $("body").scrollspy({
      target: "#mainNav",
      offset: navHeight
    });

    $(".js-scroll").on("click", function() {
      $(".navbar-collapse").collapse("hide");
    });

    window.addEventListener("scroll", () => {
      if (window.pageYOffset > 50) {
        document.querySelector(".navbar-expand-md").classList.add("navbar-reduce");
        document.querySelector(".navbar-expand-md").classList.remove("navbar-trans");
        this.setState({ logo: logo2 });
      } else {
        document.querySelector(".navbar-expand-md").classList.add("navbar-trans");
        document.querySelector(".navbar-expand-md").classList.remove("navbar-reduce");
        this.setState({ logo: logo1 });
      }
    });

    $('a.js-scroll[href*="#"]:not([href="#"])').on("click", function() {
      if (
        window.location.pathname.replace(/^\//, "") ===
          this.pathname.replace(/^\//, "") &&
        window.location.hostname === this.hostname
      ) {
        var target = $(this.hash);
        target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
        if (target.length) {
          $("html, body").animate(
            {
              scrollTop: target.offset().top - navHeight + 5
            },
            1000,
            "easeInExpo"
          );
          return false;
        }
      }
    });

    $(".js-scroll").on("click", function() {
      $(".navbar-collapse").collapse("hide");
    });
  }

  render() {
    return (
      <>
        {/* SEO Optimization */}
        <Helmet>
          <title>Ethervue Pvt Ltd | Home</title>
          <meta 
            name="description" 
            content="Ethervue Pvt Ltd specializes in IT training, Decision Science, and Participatory Irrigation Management. Explore our services and internships." 
          />
          <meta 
            name="keywords" 
            content="Ethervue, IT Training, Decision Science, Irrigation Management, Internships, Career Growth" 
          />
          <meta name="author" content="Ethervue Pvt Ltd" />

          {/* Open Graph for Social Media */}
          <meta property="og:title" content="Ethervue Pvt Ltd | Home" />
          <meta 
            property="og:description" 
            content="Discover IT training, Decision Science programs, and certified internships at Ethervue Pvt Ltd." 
          />
          <meta property="og:image" content="https://ethervue.in/img/ethervue-logo.png" />
          <meta property="og:url" content="https://ethervue.in" />
          <meta property="og:type" content="website" />

          {/* Twitter Card */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="Ethervue Pvt Ltd | Home" />
          <meta name="twitter:description" content="Get industry-ready with Ethervue's training and internships." />
          <meta name="twitter:image" content="https://ethervue.in/img/ethervue-logo.png" />
        </Helmet>

        <nav className="navbar navbar-b navbar-trans navbar-expand-md fixed-top" id="mainNav">
          <div className="container">
            <a className="navbar-brand js-scroll" href="#page-top" aria-label="Go to homepage">
              <img src={this.state.logo} alt="Ethervue Logo" style={{ maxWidth: "100px" }} />
            </a>
            <button
              className="navbar-toggler collapsed"
              type="button"
              data-toggle="collapse"
              data-target="#navbarDefault"
              aria-controls="navbarDefault"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
            <div className="navbar-collapse collapse justify-content-end" id="navbarDefault">
              <ul className="navbar-nav">
                <li className="nav-item">
                  <a className="nav-link js-scroll active" href="#home">
                    Home
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link js-scroll" href="#about">
                    Who We Are
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link js-scroll" href="#work">
                    What We Do?
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link js-scroll" href="#InternTraining">
                    Trainings/Internships
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link js-scroll" href="#contact">
                    Contact Us
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </>
    );
  }
}

export default Navbar;
